import { ServerFetch } from '../main-model'

export default class PermissionModel extends ServerFetch {
    getPermissionBy = (data) => this.authFetch({
        url: 'permission/getPermissionBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}
